<template>
    <div>
    </div>
</template>

<script>
    import betSlip from '@/mixins/betSlip'

    export default {
        name: 'BetSlipWorker',
        mixins: [betSlip],
        data() {
            return {
            }
        },
        methods: {
            isJsonString(str) {
              return typeof str == 'object'
            },
        },
        watch: {
          '$store.state.updateMatch' (m) {
            if(this.isJsonString(m)){
              this.$getItem('bets', (key, bets) => {
                    //console.log all the kay/value pairs
                    m.forEach( (match,k) => {
                      bets.forEach((obj,objIndex) => {
                          if (obj.eventId == match.id) {

                            if (match.isSuspended || match.markets.length == 0){
                              bets[objIndex].active = false
                              bets[objIndex].odd = 1
                            }
                            bets[objIndex].match.periodTime = match.periodTime
                            bets[objIndex].match.resultName = match.result.name
                            this.$set(bets, objIndex, bets[objIndex])
                            this.$store.commit("updateBetslip", bets);
                            //console.log('match')
                            this.updateBets(bets)
                          }
                      })
                    })
                }, function (err) {
              })
            }
          },
            '$store.state.updateMarket' (m) {
              if(this.isJsonString(m)){
                this.$getItem('bets', (key, bets) => {
                    //console.log all the kay/value pairs
                    m.forEach( (market,k) => {
                      market.selections.forEach( (v,k) => {
                        var objIndex = bets.findIndex(obj => obj.oddId == v.id);
                        if(objIndex >= 0){
                          bets[objIndex].active = !v.isDisabled
                          if(v.value <= 1){
                            this.bets[objIndex].active = false
                          }
                          bets[objIndex].odd = v.value
                          this.bets = bets
                          this.$set(bets, objIndex, bets[objIndex])
                          this.$store.commit("updateBetslip", bets);
                          this.updateBets(bets)
                        }
                      })
                    })
                }, function (err) {
                })
              }
            },
        },
        mounted() {
            
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/BetSlipWorker.vue